let authoredInstructionHtml = '';

export function setAuthoredInstructionHtml(value) {
  authoredInstructionHtml = String(value || '').trim();
  const instructionElement = document.querySelector('.instruction-content-text');
  if (instructionElement && authoredInstructionHtml) {
    instructionElement.innerHTML = authoredInstructionHtml;
  }
}

export function getAuthoredInstructionHtml() {
  if (authoredInstructionHtml) {
    return authoredInstructionHtml;
  }

  return '';
}
